'use strict'

exports.util = require('./util.js')
exports.resolver = require('./resolver.js')



//////////////////
// WEBPACK FOOTER
// ./~/ipld-eth-block/src/index.js
// module id = 235
// module chunks = 0